<template>
  <div class="settings-xero">
    <div class="content">
      <div v-if="error">
        <h1>Your connection to Xero failed</h1>
        <p>{{ error }}</p>
        <a :href="link" class="btn btn-outline-black btn-large mt-4">
          Reconnect to Xero
        </a>
      </div>
      <div v-else-if="connected">
        <h1>You are connected to Xero</h1>
        <p>{{ organisationName }} via {{ username }}</p>
        <a :href="link" class="btn btn-outline-black btn-large mt-4">
          Reconnect to Xero
        </a>
      </div>
      <div v-else>
        <h1>You are not connected to Xero</h1>
        <a :href="link" class="btn btn-outline-black btn-large mt-4">
          Connect to Xero
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceUser from '@/services/user'

export default {
  data () {
    return {
      error: null,
      connected: false,
      organisationName: '',
      name: '',
      link: '#'
    }
  },
  watch: {},
  computed: {
  },
  created () {},
  mounted () {
    this.init();
  },
  methods: {
    init () {
      this.getXeroInfo()
    },
    getXeroInfo () {
      let self = this;
      ServiceUser.getXeroInfo(info => {
        for(let i in info) {
          self[i] = info[i];
        }
      });
    }
  }
}
</script>
